import { useQuery } from '@tanstack/react-query';
import { type UseQueryReturnType, gqlClient, graphql } from '@tyro/api';
import { shellKeys } from '../keys';

const tyroneConversation = graphql(/* GraphQL */ `
  query tyrone_conversationHistory($conversationId: String!) {
    tyrone_conversationHistory(conversationId: $conversationId) {
      messages {
        id
        conversationId
        requestNumber
        prompt
        response
      }
    }
  }
`);

const tyroneConversationQuery = (conversationId: string) => ({
  queryKey: shellKeys.tyrone.conversation(conversationId),
  queryFn: async () =>
    gqlClient.request(tyroneConversation, { conversationId }),
});

export function useTyroneConversation(conversationId: string | null) {
  return useQuery({
    ...tyroneConversationQuery(conversationId ?? ''),
    enabled: !!conversationId,
    select: ({ tyrone_conversationHistory }) => tyrone_conversationHistory,
  });
}

export type ReturnTypeFromTyroneConversation = UseQueryReturnType<
  typeof useTyroneConversation
>;
